
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotion/referral",
      function () {
        return require("private-next-pages/promotion/referral.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotion/referral"])
      });
    }
  